import { render } from "./admin-article.vue?vue&type=template&id=04f09c65&scoped=true&ts=true"
import script from "./admin-article.vue?vue&type=script&lang=ts"
export * from "./admin-article.vue?vue&type=script&lang=ts"

import "./admin-article.vue?vue&type=style&index=0&id=04f09c65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f09c65"]])

export default __exports__